module.exports = __webpack_public_path__ + "img/connect-sheets.d1009f79.png";